import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import servicesData from "../Components/Data/ServiceData"; 
import styled from "styled-components";

const ServiceDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const serviceId = parseInt(id, 10);

  const service = servicesData.find((service) => service.id === serviceId);

  console.log("Service Data:", service); // Debugging service data
  
  if (!service) {
    return <NotFound>Service not found</NotFound>;
  }

  console.log("FAQ Data:", service.faq); // Debugging FAQ data

  return (
    <ServiceDetailWrapper>
      <ServiceHeader>
        <ServiceTitle>{service.title}</ServiceTitle>
        <ServiceImage src={service.image} alt={service.title} />
      </ServiceHeader>
      <ServiceContent>
        <ServiceDescription>{service.description}</ServiceDescription>
        <ServiceDetails>{service.details}</ServiceDetails>
        
        {service.faq && (
          <FAQSection>
            {service.faq.p ? <p>{service.faq.p}</p> : <p>No FAQ available.</p>}
            {service.faq.link && (
              <DownloadLink href={service.faq.link} download>
                {service.faq.title || "Download FAQ"}
              </DownloadLink>
            )}
          </FAQSection>
        )}

        {service.features && service.features.length > 0 && (
          <FeaturesSection>
            <FeaturesTitle>{service.featureTitle || "Key Features:"}</FeaturesTitle>
            <FeaturesList>
              {service.features.map((feature, index) => (
                <FeatureItem key={index}>{feature}</FeatureItem>
              ))}
            </FeaturesList>
          </FeaturesSection>
        )}
        
        {service.testimonial ? (
          <Testimonial>
            <QuoteIcon>❝</QuoteIcon>
            <TestimonialQuote>{service.testimonial.quote}</TestimonialQuote>
            <TestimonialAuthor>- {service.testimonial.author}</TestimonialAuthor>
          </Testimonial>
        ) : null}
        
        <ButtonGroup>
          <BackButton onClick={() => navigate("/services")}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              style={{ width: "16px", height: "16px" }}
            >
              <polyline points="15 18 9 12 15 6"></polyline>
            </svg>
            Back
          </BackButton>
          <BookButton onClick={() => navigate("/booking")}>Book Now</BookButton>
        </ButtonGroup>
      </ServiceContent>
    </ServiceDetailWrapper>
  );
};

export default ServiceDetail;



const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px; /* Space between the icon and text */
  background-color: transparent;
  color: #0078d7;
  border: 2px solid #0078d7;
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 1rem;
  cursor: pointer;
  font-weight: 500;
  transition: color 0.3s ease, background-color 0.3s ease, transform 0.2s ease;
  text-decoration: none;

  &:hover {
    color: white;
    background-color: #0078d7;
    transform: translateY(-2px);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(0, 120, 215, 0.4);
  }

  &:active {
    transform: translateY(0);
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

const ServiceDetailWrapper = styled.div`
  margin: 0 auto;
  padding: 40px 20px;
  background: linear-gradient(135deg, #ffffff, #f9fbfd);
  border-radius: 16px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  overflow: hidden;
`;

const ServiceHeader = styled.div`
  position: relative;
  margin-bottom: 40px;
`;

const ServiceImage = styled.img`
  width: 100%;
  max-height: 400px;
  object-fit: cover;
  border-radius: 16px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
`;

const ServiceTitle = styled.h1`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 2.5rem;
  color: white;
  font-weight: 800;
  background: rgba(0, 0, 0, 0.6);
  padding: 10px 20px;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  max-width: 90%;
`;

const ServiceContent = styled.div`
  text-align: left;
  max-width: 1100px;
  margin: 0 auto;
`;

const ServiceDescription = styled.p`
  font-size: 1.2rem;
  color: #444;
  line-height: 1.8;
  margin-bottom: 20px;
`;

const ServiceDetails = styled.p`
  font-size: 1rem;
  color: #555;
  line-height: 1.6;
  margin-bottom: 20px;
`;

const BookButton = styled.button`
  background-color: transparent;
  color: #0078d7;
  padding: 10px 20px;
  font-size: 1rem;
  border: 2px solid #0078d7;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
  transition: color 0.3s ease, background-color 0.3s ease, transform 0.2s ease;

  &:hover {
    color: white;
    background-color: #0078d7;
    transform: translateY(-2px);
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 20px;
`;

const Testimonial = styled.div`
  background:rgb(13, 95, 217);
  color: white;
  padding: 30px;
  border-radius: 16px;
  margin: 30px 0;
  text-align: center;
`;

const TestimonialQuote = styled.p`
  font-size: 1.0rem;
  line-height: 1.5;
  font-style: italic;
  margin-bottom: 8px;
`;

const TestimonialAuthor = styled.p`
  font-size: 1rem;
  font-weight: bold;
  font-style: italic;
  color: rgba(255, 255, 255, 0.8);
`;

const NotFound = styled.div`
  font-size: 1.5rem;
  color: #ff3b3b;
  text-align: center;
  padding: 40px;
`;

const QuoteIcon = styled.div`
  font-size: 3rem;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 5px;
`;
const FeaturesSection = styled.div`
  margin: 20px 0;
`;

const FeaturesTitle = styled.h3`
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 10px;
`;

const FeaturesList = styled.ul`
  list-style: disc;
  padding-left: 20px;
`;

const FeatureItem = styled.li`
  font-size: 1.1rem;
  color: #555;
  margin-bottom: 8px;
`;

// Styled Components
const FAQSection = styled.div`
  margin-bottom: 20px;
  background: #f4f4f4;
  padding: 15px;
  border-radius: 8px;
  text-align: center;
`;

const DownloadLink = styled.a`
  color: #0078d7;
  font-weight: bold;
  text-decoration: none;
  border: 1px solid #0078d7;
  border-radius: 4px;
  padding: 8px 12px;
  display: inline-block;
  margin-top: 10px;

  &:hover {
    background-color: #0078d7;
    color: white;
    text-decoration: none;
  }
`;